import { render, staticRenderFns } from "./ImageDetail.vue?vue&type=template&id=146c2976&scoped=true"
import script from "./ImageDetail.vue?vue&type=script&lang=js"
export * from "./ImageDetail.vue?vue&type=script&lang=js"
import style0 from "./ImageDetail.vue?vue&type=style&index=0&id=146c2976&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146c2976",
  null
  
)

export default component.exports